var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pilot-player" },
    [
      _c("pilot-menu", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showPilotMenuPage,
            expression: "showPilotMenuPage",
          },
        ],
        attrs: {
          "tour-id": _vm.tourId,
          "pilot-tours": _vm.pilotTours,
          "pilot-influencers": _vm.pilotInfluencers,
        },
        on: {
          "change-page": _vm.changePage,
          "select-tour": _vm.selectTour,
          "select-influencer": _vm.selectInfluencer,
          "show-player": _vm.showPlayer,
          close: _vm.close,
          "toggle-pilot-player-status": _vm.togglePilotPlayerStatus,
        },
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: _vm.transitionName } },
        [
          _c("pilot-influencer", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPilotInfluencerPage,
                expression: "showPilotInfluencerPage",
              },
            ],
            attrs: {
              "tour-id": _vm.tourId,
              "pilot-influencer": _vm.pilotInfluencer,
              "pilot-tours": _vm.pilotTours,
            },
            on: {
              "change-page": _vm.changePage,
              "select-tour": _vm.selectTour,
              "show-player": _vm.showPlayer,
              close: _vm.close,
              "toggle-pilot-player-status": _vm.togglePilotPlayerStatus,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pilot-tour", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showPilotTourPage,
            expression: "showPilotTourPage",
          },
        ],
        ref: "pilotTourRef",
        attrs: {
          "pilot-tour": _vm.pilotTour,
          "is-large-screen": _vm.isLargeScreen,
        },
        on: { "change-page": _vm.changePage, close: _vm.close },
      }),
      _vm._v(" "),
      _c("pilot-tooltip", { on: { confirm: _vm.showPlayer } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }